module.exports = __webpack_public_path__ + "img/length.5a870c17.png";